export interface View<State> {
    state: State;
    update: () => void;
}

export interface SeatPos {
    rowNumber: number;
    seatNumber: number;
}

export interface TicketType {
    id: number;
    name: string;
    price: string;
    seatTypeIds: number[];
    modalCount?: number;
}

export interface ProductVariant {
    id: number;
    name: string;
    unitPrice: number;
    initialUnitPrice: number;
    quantity: number;
    maxQuantity?: number;
    active: boolean;
    deleted: boolean;
}

export interface Product {
    id: number;
    name: string;
    variants: ProductVariant[];
    active: boolean;
}

export interface SerialTicketType {
    id: number;
    name: string;
    unitPrice: number;
    quantity: number;
}

export interface GiftCardType {
    id: number;
    name: string;
    unitPrice: number;
    quantity: number;
    allow_custom_value?: boolean;
    min_amount?: number;
    max_amount?: number;
    compositeKey?: string;
}

export interface CardType {
    id: number;
    name: string;
    unitPrice: number;
    membership_price: number;
    membership_duration_months: number;
    quantity: number;
}

export interface ProductCategory {
    id: number;
    name: string;
}

export interface ProductGridItem {
    variantId?: number;
    serialTicketTypeId?: number;
    giftCardTypeId?: number;
    cardTypeId?: number;
    isRenewal?: boolean;
    color: ComplimentaryColor;
    title?: string;
    active: boolean;
}

export interface ProductGrid {
    title: string;
    id: number;
    products: ProductGridItem[][];
}

interface ISeat {
    number: number;
    row: number;
    section_id?: string;
    section_name?: string;
}

export interface ISeatResponse extends ISeat {
    type: number;
    price: string;
}

export interface IAdditionalSeatResponse {
    uuid: string;
    type: number;
    price: string;

    /**
     * When a new additional seat is added, it doesn't have a UUID until one comes
     * back from the server response. This is temporarily used to distinguish seats
     * in that state.
     */
    tempId?: string;
}

export interface ISeatsResponse {
    sold?: ISeat[]; // Sold tickets only (ACTIVE/USED) - used by ticket office
    reserved?: ISeat[]; // Reserved/pending seats - used by ticket office
    unavailable?: ISeat[]; // All unavailable seats (sold + reserved combined) - used by customer facing monitor
    disabled: ISeat[];
    booked: ISeatResponse[];
    additional?: IAdditionalSeatResponse[];
    capacity?: {
        total: number;
        available: number;
        sold: number;
    };
}

export interface Seats {
    numbered: ISeatResponse[];
    unnumbered: IAdditionalSeatResponse[];
}

export const ComplimentaryColorArray = [
    'pink',
    'light-blue',
    'dark-blue',
    'green',
    'muted-orange',
    'bright-orange',
    'purple',
    'dark-red',
    'acid-green',
    'yellow',
] as const;
export type ComplimentaryColor = (typeof ComplimentaryColorArray)[number];
